import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { useSelector } from "react-redux"
import type { TerminalType } from "../../../graphql/types"
import { Select, SelectProps } from "../../uiKit/Select/Select"
import { getDataForTerminalSinglePicker } from "./selectors"
import { omit } from "ramda"
import { StateObject } from "../../redux/types"

type Props = Pick<SelectProps, "dropDownClassName" | "buttonClassName" | "size" | "disabled"> & {
    terminalTypes: TerminalType[]
    selectedTerminalId: Maybe<string>
    onChange: (terminalId: string) => void
}

export const SingleTerminalPicker = ({ terminalTypes, selectedTerminalId, onChange, ...restProps }: Props) => {
    const data = useSelector((state: StateObject) => getDataForTerminalSinglePicker(state, terminalTypes))

    const handleSetLocationsFilter = (terminalId: string) => {
        onChange(terminalId)
    }

    const selectProps = omit(["terminalType", "selectedTerminalId", "onChange"], restProps)
    return (
        <Select
            onChange={handleSetLocationsFilter}
            labels={{
                noSelected: <span className="opacity-50">Select terminal</span>,
                singleSelected: label => label,
            }}
            data={data}
            value={selectedTerminalId}
            {...selectProps}
        />
    )
}
